import type { CreateChallengeInput } from "@/lib/api";

/**
 * What a client-simulated challenge needs at creation that a server one does not:
 * the encrypted maze file students download, its Drive id, and their dataset link.
 */
export interface ClientMazeInput {
  file: File | null;
  maze_id: string;
  exploration_data_url: string;
}

export const EMPTY_CLIENT_MAZE: ClientMazeInput = {
  file: null,
  maze_id: "",
  exploration_data_url: "",
};

/** What is still missing, in the words the stepper shows. */
export function clientMazeMissing(value: ClientMazeInput): string[] {
  return [
    ...(value.file ? [] : ["the maze file"]),
    ...(value.maze_id.trim() ? [] : ["the Drive file id"]),
    ...(value.exploration_data_url.trim() ? [] : ["the exploration dataset URL"]),
  ];
}

/** The create-form fields for this mode. */
export function clientMazePayload(
  value: ClientMazeInput,
): Pick<CreateChallengeInput, "maze_id" | "exploration_data_url" | "maze_file"> {
  return {
    maze_id: value.maze_id.trim(),
    exploration_data_url: value.exploration_data_url.trim(),
    maze_file: value.file ?? undefined,
  };
}
